import User from '@/utils/apiModules/User';
import Common from '@/utils/apiModules/Common';
import Menu from '@/utils/apiModules/Menu';
import Role from '@/utils/apiModules/Role';
import Organization from '@/utils/apiModules/Organization';
import Exam from '@/utils/apiModules/Exam';
import Project from '@/utils/apiModules/Project';
import Product from '@/utils/apiModules/Product';
import Template from '@/utils/apiModules/Template';
import RiskLibrary from '@/utils/apiModules/RiskLibrary';
import IconLibrary from '@/utils/apiModules/IconLibrary';
import CheckStandard from '@/utils/apiModules/CheckStandard';
import CheckTable from '@/utils/apiModules/CheckTable';
import Video from '@/utils/apiModules/Video';
import Fx from '@/utils/apiModules/Fx';
import TenantGroup from '@/utils/apiModules/TenantGroup';
import TenantAnalysis from '@/utils/apiModules/TenantAnalysis';
import Log from '@/utils/apiModules/Log';
import PushMessage from '@/utils/apiModules/PushMessage';
import Instruction from '@/utils/apiModules/Instruction';

const Api = {
  user: User,
  common: Common,
  menu: Menu,
  role: Role,
  organization: Organization,
  exam: Exam,
  project: Project,
  product: Product,
  template: Template,
  riskLibrary: RiskLibrary,
  iconLibrary: IconLibrary,
  checkStandard: CheckStandard,
  checkTable: CheckTable,
  video: Video,
  fx: Fx,
  tenantGroup: TenantGroup,
  tenantAnalysis: TenantAnalysis,
  log: Log,
  pushMessage: PushMessage,
  instruction: Instruction
}

export default Api
